module.exports = {
	"blended_directory": "blended_directory",
	"active_organsation": "active_organsation"
};


/** WEBPACK FOOTER **
 ** ./~/blended-hostlib-js/Controller/config.json
 **/